/* eslint-disable import/prefer-default-export */
import { collectionsAxios } from 'util/Api';
import {
  SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
} from '../../constants/ActionTypes';

export const createRefund = (data) => (dispatch) => {
  collectionsAxios.post('refund-by-admin', data).then((axiosResponse) => {
    const response = axiosResponse?.data;
    //TODO check if creating refund is successful
    dispatch({ type: SHOW_MESSAGE, payload: response?.message || response?.data?.message || 'Succesfully created refunded', code: response?.code });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.message });
    }
    console.error('Error: ', error.message);
  });
};


export const createPaymentTransaction = (data) => (dispatch) => {
  collectionsAxios.post('hp-request-to-pay', data).then((axiosResponse) => {
    const response = axiosResponse?.data;
    //TODO check if creating refund is successful
    dispatch({ type: SHOW_MESSAGE, payload: response?.message || response?.data?.message || 'Succesfully created transaction', code: response?.code });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.message });
    }
    console.error('Error: ', error.message);
  });
};
